/** A card's artwork state (Explore gaps E4). Absent on older servers. */
export const GENERATION_STATE = {
  READY: "READY",
  GENERATING: "GENERATING",
  FAILED: "FAILED",
  SKIPPED: "SKIPPED",
};

/** GENERATING = gradient and no Start yet; every other state is startable. */
export const isCardGenerating = (card) =>
  card?.generation_state === GENERATION_STATE.GENERATING;
